export const FONT_SIZE_PRESETS = [
    6, 8, 9, 10, 11, 12, 14, 18, 24, 30, 36, 48, 60, 72, 84, 96, 108, 120, 140, 150, 160, 180, 200, 250, 300, 400, 500,
];
